import {
  Dialog,
  DialogContent,
  Typography,
  DialogActions,
} from '@mui/material';
import { useTransactionFormModal } from '@/hooks/stores/useTransactionFormModal';
import { useNavigate } from 'react-router-dom';
import { SVButton } from '@/components/core';

type MissingAccountsModalProps = {
  title: string;
  content: string;
  submitText: string;
  submitRoute: string;
};

export default function MissingAccountsModal({
  title,
  content,
  submitText,
  submitRoute,
}: MissingAccountsModalProps) {
  const navigate = useNavigate();
  const { open, closeTransactionFormModal } = useTransactionFormModal();

  function handleOnSubmit() {
    closeTransactionFormModal();
    navigate(submitRoute);
  }

  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      open={open}
      onClose={() => closeTransactionFormModal()}>
      <DialogContent>
        <Typography variant="h4">{title}</Typography>
        <Typography>{content}</Typography>
      </DialogContent>
      <DialogActions>
        <SVButton
          variant="outlined"
          onClick={() => closeTransactionFormModal()}>
          Cancel
        </SVButton>
        <SVButton onClick={handleOnSubmit}>{submitText}</SVButton>
      </DialogActions>
    </Dialog>
  );
}
